import axios from 'axios'
import Moment from 'moment'
import { useEffect, useState } from 'react'
import Calendar from 'react-calendar'
import * as TypIcons from 'react-icons/ti'
import { Link, useNavigate } from 'react-router-dom'
import authService from '../Components/Login/auth.service'
import {
    ContainerPage,
    TitleOfPage,
    TitlePage1,
    TitlePage2
} from '../Components/Main'
import ProfileDireita from '../Components/ProfileDireita'
import SidebarMobile from '../Components/SideBar-right/SidebarMobile'
import '../styles/components/Calendar.css'
import '../styles/pages/relatorio.css'
import ModalEmail from '../pages/MenuDireito/MenuDireito-Modal/ModalEnvioEmailChecklist'

function ListagemChecklist() {
    const dateAtual = new Date()
    if (sessionStorage.DataInicio === undefined) {
        sessionStorage.DataInicio = new Date(
            dateAtual.getFullYear(),
            dateAtual.getMonth(),
            1
        )
        sessionStorage.DataFim = new Date()
    }
    const [date, setDate] = useState([
        Moment(`${sessionStorage.DataInicio} 00:00:00`).isValid()
            ? new Date(`${sessionStorage.DataInicio} 00:00:00`)
            : new Date(sessionStorage.DataInicio),
        Moment(`${sessionStorage.DataFim} 23:59:59`).isValid()
            ? new Date(`${sessionStorage.DataFim} 23:59:59`)
            : new Date(sessionStorage.DataFim)
    ])
    const setSeacrhDate = e => {
        setDate(e)
        sessionStorage.DataInicio = e[0].toISOString().slice(0, 10)
        e[1].setDate(e[1].getDate() - 1)
        sessionStorage.DataFim = e[1].toISOString().slice(0, 10)
        window.location.reload()
    }
    const history = useNavigate()
    var user = authService.getCurrentUser()
    const [auditorias, setAuditorias] = useState([])
    const [searchTerm, setSearchTerm] = useState('')
    const [unidades, setUnidades] = useState([])
    const [modalOpen, setModalOpen] = useState(false)
    const [auditoria, setAuditoria] = useState([])

    const [notaMin, setNotaMin] = useState(0)
    const [notaMax, setNotaMax] = useState(101)

    //obtem unidades vinculadas ao usuário
    useEffect(() => {
        axios
            .get(
                process.env.REACT_APP_API_URL +
                '/api/v1/unidadeUser/list/' +
                user[0].IdEmpresa +
                '/' +
                user[0].IdPessoa
            )
            .then(response => {
                setUnidades(response.data)
                if (sessionStorage.IdUnidade === undefined) {
                    sessionStorage.IdUnidade = response.data[0].IdUnidade
                    sessionStorage.uniRazaoSocial = response.data[0].uniRazaoSocial
                }
            })
    }, [])

    //obtem auditorias da unidade destacada
    useEffect(() => {
        axios
            .get(
                process.env.REACT_APP_API_URL +
                '/api/v1/checklist/listunidade/' +
                user[0].IdEmpresa +
                '/' +
                sessionStorage.IdUnidade +
                '/' +
                sessionStorage.DataInicio +
                '/' +
                sessionStorage.DataFim
            )
            .then(response => {
                setAuditorias(response.data)
            })
    }, [])

    //quando altera unidade na seleção
    function handleUnidadeChange(event) {
        sessionStorage.IdUnidade = event.target.value
        sessionStorage.uniRazaoSocial =
            event.target.options[event.target.selectedIndex].text
        window.location.reload()
    }
    //quando altera o tipo de visualizacao
    function handleDashChange(event) {
        sessionStorage.visualizacao = event.target.value
        if (event.target.value === 'Dashboard') {
            history('/Home/')
        }
        else if (event.target.value === 'Listagem') {
            history('/ListagemHome')
        }
        else if (event.target.value === 'Checklist') {
            history('/ListagemChecklist')
        }
    }
    function handleToggleComplete() {
        setModalOpen(true)
    }
    function handleAuditoria(id, event) {
        if (event.target.checked) {
            const newList = auditoria.filter(item => item.IdRetornoObservacao !== id)
            const newList2 = newList.concat({
                IdRetornoObservacao: id
            })
            setAuditoria(newList2)
        } else {
            const newList = auditoria.filter(item => item.IdRetornoObservacao !== id)
            setAuditoria(newList)
        }
        //console.log(auditoria)
    }
    const optionsDT = {
        day: "numeric",
        month: "numeric",
        year: "numeric",
    };
    //console.log(auditorias)
    return (
        <div className="displayInteract">
            {modalOpen && (
                <ModalEmail setOpenModal={setModalOpen} auditorias={auditoria} />
            )}
            <ContainerPage>
                {/* Logo */}
                <div id="containerHead1">
                    <div className="logo" />{' '}
                </div>
                {/* Titulo e Pesquisa */}
                <div id="containerHead2">
                    <TitleOfPage>
                        <TitlePage1>
                            {' '}
                            {sessionStorage.uniRazaoSocial} / CHECKLISTS
                        </TitlePage1>
                        <Link to="/Home">
                            <TitlePage2>Checklists de {date[0].toLocaleString('pt-br', optionsDT)}
                                {date[0].toLocaleString('pt-br', optionsDT) !== date[1].toLocaleString('pt-br', optionsDT)
                                    ? ' à ' + date[1].toLocaleString('pt-br', optionsDT) : ''}</TitlePage2>
                        </Link>
                    </TitleOfPage>
                    <div id="containerPesquisaModal">
                        <input
                            className="fnamePadrao"
                            placeholder="Filtrar Restaurante"
                            type="text"
                            id="fname1"
                            name="fname"
                            onChange={event => {
                                setSearchTerm(event.target.value)
                            }}
                        />
                        <button
                            className="buttonModalPadraoPes"
                            onClick={handleToggleComplete}
                        >
                            <TypIcons.TiMail />
                        </button>
                    </div>
                </div>

                <div className="cxLegendaRel">
                    <label htmlFor="" className="lgHLegenda">
                        Filtro:
                    </label>
                    <button
                        className="lgHNeutro"
                        onClick={event => {
                            setNotaMax(101)
                            setNotaMin(0)
                        }}
                    >
                        TODAS
                    </button>
                    <button
                        className="lgHAcima"
                        onClick={event => {
                            setNotaMax(101)
                            setNotaMin(90)
                        }}
                    >
                        BOM
                    </button>
                    <button
                        className="lgHMedia"
                        onClick={event => {
                            setNotaMax(80)
                            setNotaMin(70)
                        }}
                    >
                        REGULAR
                    </button>
                    <button
                        className="lgHOrange"
                        onClick={event => {
                            setNotaMax(70)
                            setNotaMin(30)
                        }}
                    >
                        RUIM
                    </button>
                    <button
                        className="lgHAbaixo"
                        onClick={event => {
                            setNotaMax(30)
                            setNotaMin(0)
                        }}
                    >
                        INACEITÀVEL
                    </button>
                </div>

                <div className="tabelaPadrao">
                    <table>
                        <thead>
                            <th>Auditoria</th>
                            <th>Checklist</th>
                            <th>Auditor</th>
                            <th>Data de Execução</th>
                            <th>Nota</th>
                            <th>Indicador</th>
                            <th>Envio</th>
                        </thead>
                        {auditorias
                            .filter(val => {
                                if (
                                    searchTerm === '' &&
                                    parseInt(val.rtoPontuacao) >= notaMin &&
                                    parseInt(val.rtoPontuacao) < notaMax
                                ) {
                                    return val
                                } else if (
                                    //(
                                    val.otpDescricao
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase()) ||
                                    val.pesNome
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase()) ||
                                    val.locDescricao
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase()) ||
                                    val.rtoResponsavelLocal
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase()) ||
                                    val.rtoResponsavelEmail
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase()) ||
                                    val.rtoResponsavelFuncao
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase())
                                    //)
                                    &&
                                    parseInt(val.rtoPontuacao) >= notaMin &&
                                    parseInt(val.rtoPontuacao) < notaMax
                                ) {
                                    return val
                                }
                            })
                            .map(audit => (
                                <tbody>
                                    <tr>
                                        <td>{audit.IdRetornoObservacao}</td>
                                        <td>{audit.otpDescricao}</td>
                                        <td>{audit.pesNome}</td>
                                        <td>{audit.rtoIniciadoEm}</td>
                                        <td>{audit.rtoPontuacao}</td>
                                        <td>{' '}
                                            <a href={`https://ws.hitperformance.com.br/Cozinha/RelatorioChecklist?id=${audit.IdRetornoObservacao}`} target={'_blank'}>
                                                <div
                                                    className={`class-${parseInt(audit.rtoPontuacao) < 30
                                                        ? 'red1'
                                                        : parseInt(audit.rtoPontuacao) < 60 &&
                                                            parseInt(audit.rtoPontuacao) >= 30
                                                            ? 'orange1'
                                                            : parseInt(audit.rtoPontuacao) < 80 &&
                                                                parseInt(audit.rtoPontuacao) >= 60
                                                                ? 'yellow1'
                                                                : 'green1'
                                                        }`}
                                                >
                                                    <TypIcons.TiDocumentText />
                                                </div>
                                            </a>
                                        </td>
                                        <td>
                                            <div>
                                                <input
                                                    className="CheckAcess"
                                                    type="checkbox"
                                                    key={audit.IdRetornoObservacao}
                                                    onChange={event =>
                                                        handleAuditoria(audit.IdRetornoObservacao, event)
                                                    }
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            ))
                        }
                    </table>
                </div>
            </ContainerPage>

            <nav className="esconderFiltro">
                <ProfileDireita />
                <div className="calendarRelatorio2">
                    <form action="">
                        <h1>Selecione:</h1>
                        <label htmlFor="">Cliente/Unidade:</label>
                        <select
                            name="IdUnidade"
                            onChange={event => {
                                handleUnidadeChange(event)
                            }}
                        >
                            {unidades.map(unidade => (
                                <option
                                    value={unidade.IdUnidade}
                                    selected={
                                        parseInt(unidade.IdUnidade) ===
                                        parseInt(sessionStorage.IdUnidade)
                                    }
                                >
                                    {unidade.uniRazaoSocial}
                                </option>
                            ))}
                        </select>
                        <label htmlFor="">Visualização:</label>
                        <select
                            name="IdUnidade"
                            onChange={event => {
                                handleDashChange(event)
                            }}
                        >
                            <option
                                value={'Dashboard'}
                                selected={'Dashboard' === sessionStorage.visualizacao}
                            >
                                Dashboard
                            </option>
                            <option
                                value={'Listagem'}
                                selected={'Listagem' === sessionStorage.visualizacao}
                            >
                                Listagem
                            </option>
                            <option
                                value={'Checklist'}
                                selected={'Checklist' === sessionStorage.visualizacao}
                            >
                                Checklist
                            </option>
                        </select>
                        <label>Periodo Analisado:</label>
                        <Calendar
                            type="Hebrew"
                            onChange={setSeacrhDate}
                            value={date}
                            selectRange={true}
                        />
                    </form>
                </div>
            </nav>

        </div>
    )
}

export default ListagemChecklist